export const storeOptions = {
    state: {
    },
    mutations: {
    },
    getters: {
    }
}
